import { Coord } from "../../../../../../../src/types/Interface";

export const checkSameCoord = (c1: Coord, c2: Coord) => c1.x == c2.x && c1.y == c2.y;